import React, {useEffect, useState} from 'react';
import {Button, Grid, Header, Icon, Input, Label, Pagination, Segment, Select, Table} from 'semantic-ui-react';
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import {toast} from "react-toastify";
import {SessionUser} from "../../../models/session-user";
import SessionStorage from "../../../store/session";
import {useBlockUI} from "../../../shared/services/block-ui-service";
import {ToasterConfig} from "../../../config/ToasterConfig";
import {Fleet} from "../../../models/fleet";
import {FleetFilter} from "../../../filters/fleet-filter";
import useBusinessUnitService from "../../../services/backoffice/hooks/useBusinessUnitService";
import {ShortDto} from "../../../models/short-dto";
import useClientService from "../../../services/backoffice/hooks/useClientService";
import useFleetService from "../../../services/backoffice/hooks/useFleetService";
import TooltipInfo from "../../../components/tooltip/tooltip";

const FleetList = () => {
    const [fleets, setFleets] = useState<Fleet[]>([]);
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [filter, setFilter] = useState<FleetFilter>()
    const [totalPages, setTotalPages] = useState<number>()
    const [sessionUser, setSessionUser] = useState<SessionUser>();
    const [clients, setClients] = useState<ShortDto[]>([]);
    const [businessUnits, setBusinessUnits] = useState<ShortDto[]>([])
    const {getAllGetUnitsShortDto} = useBusinessUnitService();
    const {getAllClientsShortDto} = useClientService();
    const {getFleets, activeFleet, deactiveFleet, deleteFleet} = useFleetService();
    const blockUI = useBlockUI();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }

        updateSessionUser()
    }, [])
    const [showFilters, setShowFilters] = useState(false);

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };
    useEffect(() => {
        listFleets();
    }, [filter?.Page]);


    async function listFleets() {
        setLoading(true)
        const response = (await getFleets(filter).finally(() => setLoading(false)));
        setTotalPages(response.totalPages);
        setFleets(response.itens);
    }

    useEffect(() => {
        function ListClients() {
            getAllClientsShortDto().then((response) => {
                setClients(response);
            })
                .catch(error => {
                })
        }

        ListClients()
    }, [])

    useEffect(() => {
        function ListBusinessUnits() {
            getAllGetUnitsShortDto().then((response) => {
                setBusinessUnits(response);
            })
                .catch(error => {
                })
        }

        ListBusinessUnits()
    }, [])


    const toggleActivationFleet = async (fleet: Fleet, activate?: boolean) => {
        try {
            const result = window.confirm(`Tem certeza que deseja ${fleet.isActive ? 'desativar' : 'ativar'} a Operação ${fleet.operationName}?`);
            if (!result) return
            setLoading(true);
            if (fleet) {
                const result = !fleet.isActive ? await activeFleet(fleet.id) : await deactiveFleet(fleet.id);
                if (!!result) {
                    toast.success(`A Operação foi ${fleet.isActive ? 'desativada' : 'ativada'} com sucesso`, ToasterConfig.success);
                    listFleets()
                }
            }
            setLoading(false);
        } catch (error: any) {
            toast.warn(`Falha ao ${fleet.isActive ? 'desativar' : 'ativar'} Operação`, ToasterConfig.error);
            setLoading(false);
            setError(error.message);
        }
    };

    async function deleteFleetFunction(fleet: Fleet) {
        try {
            const confirm = window.confirm(`Tem certeza que deseja apagar o Fleet?`);

            if (confirm) {
                if (fleet) {
                    await deleteFleet(fleet.id);
                    toast.success('Operação deletada com sucesso', ToasterConfig.success);
                    listFleets()
                }
                setLoading(false);
            }
        } catch (error: any) {
            toast.warn(`Falha ao deletar Operação`, ToasterConfig.error);
            setLoading(false);
            setError(error.message);
        }
    }

    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Operações
            </Header>
            <Table.Row>
                <Table.HeaderCell>
                    {(sessionUser?.userData?.profile === 'Admin' || 'Manager') && (
                        <TooltipInfo
                            content="É necessário criar uma operação para que os cálculos de premiação funcionem corretamente. Sem uma operação, não é possível calcular as premiações dos motoristas."
                            trigger={
                                <Button color="green" onClick={() => navigate('/backoffice/fleets/create/')}>
                                    <Icon name="plus" /> Novo
                                </Button>
                            }
                        />
                    )}
                </Table.HeaderCell>

                <Table.HeaderCell colSpan="4">
                    <Button onClick={toggleFilters} color={"green"}>
                        <Icon name={showFilters ? 'hide' : 'unhide'}/>
                        {showFilters ? 'Ocultar filtros' : 'Exibir filtros'}
                    </Button>
                </Table.HeaderCell>
            </Table.Row>
            {showFilters && (
                <Segment>
                    <Grid stackable doubling padded>
                        <Grid.Row>
                            <Grid.Column width={6}>
                                <label htmlFor="operationName">Nome da Operação</label>
                                <TooltipInfo content="Informe o nome da operação para filtrar os resultados." trigger={<label htmlFor="operationName">Nome da Operação</label>} />
                                <Input
                                    fluid
                                    id="operationName"
                                    icon="search"
                                    type="text"
                                    placeholder="Nome da Operação"
                                    value={filter?.operationName ?? ''}
                                    onChange={(event) =>
                                        setFilter({ ...filter, operationName: event.target?.value })
                                    }
                                />
                            </Grid.Column>
                            <Grid.Column width={4}>
                                <label htmlFor="client">Cliente da Operação</label>
                                <Select clearable
                                        placeholder="Cliente da Operação"
                                        fluid
                                        search
                                        selection
                                        options={clients}
                                        value={filter?.clientId ?? ''}
                                        onChange={(event, data) =>
                                            //@ts-ignore
                                            setFilter({...filter, clientId: data.value})
                                        }
                                />

                            </Grid.Column>
                            <Grid.Column width={4}>
                                <label htmlFor="businessUnit">Unidade de Negócio da Operação</label>
                                <Select clearable
                                        placeholder="Unidade de Negócio da Operação"
                                        fluid
                                        search
                                        selection
                                        options={businessUnits}
                                        value={filter?.businessUnitId ?? ''}
                                        onChange={(event, data) =>
                                            //@ts-ignore
                                            setFilter({...filter, businessUnitId: data.value})
                                        }
                                />
                            </Grid.Column>
                            <Grid.Column width={2} verticalAlign="bottom">
                                <Button color={"green"} onClick={listFleets}>Buscar</Button>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>

                        </Grid.Row>
                    </Grid>
                </Segment>
            )}


            <Table color={"green"}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>#</Table.HeaderCell>
                        <Table.HeaderCell>Nome</Table.HeaderCell>
                        <Table.HeaderCell>Cliente</Table.HeaderCell>
                        <Table.HeaderCell>Unidade de Negócio</Table.HeaderCell>
                        <Table.HeaderCell>Criado em</Table.HeaderCell>
                        <Table.HeaderCell>Ativo</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                {(sessionUser?.userData?.profile === 'Admin' || 'Manager') &&
                    <Table.Body>
                        {fleets?.map((fleet) => (
                            <Table.Row key={fleet.id}>
                                <Table.Cell>
                                    <Button.Group>
                                        <TooltipInfo
                                            content="Editar frota"
                                            trigger={
                                                <Button
                                                    color="blue"
                                                    onClick={() => {
                                                        setLoading(true);
                                                        navigate('/backoffice/fleets/edit/' + fleet.id);
                                                    }}
                                                    icon="edit"
                                                />
                                            }
                                        />

                                        <TooltipInfo
                                            content="Configurar bônus da frota"
                                            trigger={
                                                <Button
                                                    color="green"
                                                    onClick={() => {
                                                        setLoading(true);
                                                        navigate(`/backoffice/fleets/bonus-configs/?operationId=${fleet.id}`);
                                                    }}
                                                    icon="list"
                                                />
                                            }
                                        />

                                        <TooltipInfo
                                            content="Ver motoristas da frota"
                                            trigger={
                                                <Button
                                                    color="green"
                                                    onClick={() => {
                                                        navigate(`/backoffice/fleets/${fleet.id}/drivers`);
                                                    }}
                                                    icon="truck"
                                                />
                                            }
                                        />

                                        <TooltipInfo
                                            content="Excluir frota"
                                            trigger={
                                                <Button
                                                    color="red"
                                                    onClick={() => deleteFleetFunction(fleet)}
                                                    icon="trash"
                                                />
                                            }
                                        />

                                        <TooltipInfo
                                            content={fleet.isActive ? "Desativar frota" : "Ativar frota"}
                                            trigger={
                                                <Button
                                                    color={fleet.isActive ? 'red' : 'green'}
                                                    onClick={() => toggleActivationFleet(fleet)}
                                                    icon={fleet.isActive ? 'power off' : 'power'}
                                                />
                                            }
                                        />
                                    </Button.Group>

                                </Table.Cell>
                                <Table.Cell>{`${fleet.operationName}`}</Table.Cell>
                                <Table.Cell>{`${fleet?.clientName}`}</Table.Cell>
                                <Table.Cell>{`${fleet?.businessUnitName}`}</Table.Cell>
                                <Table.Cell>{moment(fleet.createdAt).format('DD/MM/YY HH:mm')}</Table.Cell>
                                <Table.Cell>
                                    <Label key={fleet.id}
                                           color={!fleet.isActive ? 'red' : 'green'}>{fleet.isActive ? 'Sim' : 'Não'}</Label>
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>}
            </Table>
            <Pagination totalPages={totalPages ?? 0}
                        defaultActivePage={filter?.Page ?? 1}
                        onPageChange={(e, {activePage}) => {
                            setFilter({...filter, Page: activePage as number})
                        }
                        }>
            </Pagination>
        </div>
    );
};

export default FleetList;
